export const medications = `
 medicationsPage: entry(slug: "medikamente", site: $site) {
    slug
    title
    url
  }
  medications: entries(collection: "medication", site: $site, sort: "title asc") {
    data {
      __typename
      id
      slug
      ... on Entry_Medication_Medication {
        id
        slug
        active_ingredients {
          title
          slug
        }
        active_ingredients_and_delivery_form {
          strengths {
            title
          }
          delivery_form {
            title
          }
        }
        authHolder
        last_modified(format: "d.m.Y")
        title
        trading_names {
          trading_name
        }
      }
    }
  }
`
